/**
 * Randomizes hero photos on page load by selecting from data-photo-urls.
 * This allows server-side caching while achieving per-visit randomization.
 * Also cycles through photos on hover with debouncing.
 */
export function heroPhotoRandomInit() {
  const images = document.querySelectorAll<HTMLImageElement>('.hero-image-random')
  
  images.forEach((img) => {
    const photoUrlsJson = img.dataset.photoUrls
    
    if (!photoUrlsJson) {
      img.style.opacity = '1'
      return
    }
    
    let photoUrls: string[]
    try {
      photoUrls = JSON.parse(photoUrlsJson)
    } catch (e) {
      img.style.opacity = '1'
      return
    }
    
    if (!Array.isArray(photoUrls) || photoUrls.length === 0) {
      img.style.opacity = '1'
      return
    }

    // Track current index
    let currentIndex = Math.floor(Math.random() * photoUrls.length)
    const randomPhotoUrl = photoUrls[currentIndex]
    
    // Preload the initial random image before swapping to prevent flicker
    const preloadImg = new Image()
    preloadImg.onload = () => {
      img.src = randomPhotoUrl
      img.style.opacity = '1'
    }
    preloadImg.onerror = () => {
      // If random image fails to load, show the original
      img.style.opacity = '1'
    }
    preloadImg.src = randomPhotoUrl

    // Only set up hover if there are multiple photos
    if (photoUrls.length > 1) {
      let hoverTimeout: number | null = null
      let isChanging = false

      const changePhoto = () => {
        if (isChanging) return
        
        isChanging = true
        
        // Move to next photo
        currentIndex = (currentIndex + 1) % photoUrls.length
        const nextPhotoUrl = photoUrls[currentIndex]
        
        // Fade out current image
        img.style.opacity = '0'
        
        // Preload next image
        const nextImg = new Image()
        nextImg.onload = () => {
          // Wait for fade out to complete before swapping
          setTimeout(() => {
            img.src = nextPhotoUrl
            // Fade in new image
            img.style.opacity = '1'
            isChanging = false
          }, 200) // Match the CSS transition duration
        }
        nextImg.onerror = () => {
          // Restore opacity if image fails to load
          img.style.opacity = '1'
          isChanging = false
        }
        nextImg.src = nextPhotoUrl
      }

      img.addEventListener('mouseenter', () => {
        // Debounce: wait 300ms before changing photo
        hoverTimeout = window.setTimeout(() => {
          changePhoto()
        }, 300)
      })

      img.addEventListener('mouseleave', () => {
        // Cancel the timeout if user leaves before debounce completes
        if (hoverTimeout !== null) {
          clearTimeout(hoverTimeout)
          hoverTimeout = null
        }
      })
    }
  })
}
